<template>
  <complex-select
    :tb-head="Head"
    :tb-data="Data"
    :key-str="keyword"
    v-model="value1"
    @select="onSelect"
  />
</template>
<script>
import complexSelect from "@/components/common/complexSelect";
export default {
  components: {
    complexSelect,
  },
  props: {
    init: {
      type: Boolean,
      default: false,
    },
    source: {
      type: Array,
      default: () => [],
    },
    keyword: {
      type: String,
      default: "CostName",
    },
    value: {},
  },
  data() {
    return {
      api: require("@/api/ba/cost").default,
      Head: [
        { Value: "ClassName", Name: "类别筛选", Width: "160", Custom: true },
        { Value: "CostNo", Name: "费用编号", Width: "180" },
        { Value: "CostName", Name: "费用名称", Width: "150" },
      ],
      Data: [],
      value1: "",
    };
  },
  watch: {
    value() {
      // console.log("watch", this.value);
      this.value1 = this.value;
    },
    source() {
      this.Data = this.source;
    },
  },
  mounted() {
    this.value1 = this.value;
    if (this.init) this.initData();
    else this.Data = this.source;
  },
  methods: {
    initData() {
      console.log("初始化");
      this.api.list({ Status: 1 }).then((res) => {
        if (res.Code == 0) this.Data = res.Data;
      });
    },
    onSelect(data) {
      console.log("select", data);
      this.$emit("input", data[this.keyword]);
      this.$emit("select", data);
    },
  },
};
</script>